import { SVGProps } from 'react';

const Cloudy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 0 1 0 9"
    />
  </svg>
);
export default Cloudy;
